import React, {useState} from 'react';
import {Button, Modal} from 'antd';
import {getAgainHandler} from '../../store/TableRedux/TableRedux';
import {toast} from 'react-toastify';
import {useDispatch} from 'react-redux';
import Pallet from "../../http_request/Model/pallet/Pallet";
import ResultComponent from "../../microComponents/modals/ResultComponent";


const Confused = ({data}) => {
    const [checked, setChecked] = useState(false);
    const [openResult, setOpenResult] = useState(false);

    const [loading, setLoading] = useState(false);
    const [open, setOpen] = useState(false);
    const dispatch = useDispatch();

    const handleShow = () => {

        setOpen(true);

    };


    const handleOk = () => {


        Pallet.request({
            beforeSend: () => {
                setLoading(true);
            }, success: (result) => {
                console.log(result)
                setChecked(!checked)
                setOpen(false)
                 dispatch(getAgainHandler())

                toast.success('تغییرات با موفقیت انجام شد.');

            }, error: (error) => {
                toast.error(error.data.message);

            }, final: () => {
                setLoading(false);
            },


        }).palletConfused(data.palletId);


    };


    const handleCancel = () => {
        setOpen(false);
    };

    return (
        <>

            <ResultComponent openResult={openResult} setOpenResult={setOpenResult}
                             status="success"
                             title={`کد تایید: ${888}`}
                             extra={[

                                 <Button key="buy" onClick={() => {
                                     setOpenResult(false)
                                 }}>بستن</Button>,
                             ]}

            />


            <div  >
                <div className='py-1 px-4' onClick={handleShow}> مخدوش کردن</div>

                <Modal
                    open={open}
                    title='مخدوش کردن شناسه'
                    onOk={handleOk}
                    onCancel={handleCancel}
                    footer={[
                        <Button className='defBtn redBtn' key='back' onClick={handleCancel}>
                            انصراف
                        </Button>,
                        <Button className='defBtn blueBtn' key='submit' type='primary' loading={loading}
                                onClick={handleOk}>
                            ثبت
                        </Button>,

                    ]}
                >
                    <p>آیا از مخدوش کردن اطمینان دارید؟</p>
                </Modal>
            </div>
        </>

    );
};
export default Confused;